module.exports = __webpack_public_path__ + "img/green-palm.77a02f28.png";